import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal, SectionLabel } from "@/lib/Reveal";
import { GALLERY } from "@/lib/data";

const FILTERS = ["All Work", "Boiler Installs", "Servicing", "Gas Fires", "Cookers & Hobs", "Heat Pumps", "Hot Water", "Plumbing"];

export const Gallery = () => {
  const [filter, setFilter] = useState("All Work");
  const items = filter === "All Work" ? GALLERY : GALLERY.filter((g) => g.category === filter);

  return (
    <section id="gallery" data-testid="gallery-section" className="py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <Reveal><SectionLabel>07 / Recent jobs</SectionLabel></Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-display font-extrabold uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl text-white mt-4">
                Our work, on the record.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <div className="flex flex-wrap gap-2">
              {FILTERS.map((f) => (
                <button
                  key={f}
                  onClick={() => setFilter(f)}
                  data-testid={`gallery-filter-${f.toLowerCase().replace(/\s/g, "-")}`}
                  className={`font-mono text-xs uppercase tracking-[0.15em] px-4 py-2 border rounded-sm transition-all ${
                    filter === f ? "border-torch bg-torch/10 text-torch" : "border-neutral-800 text-neutral-500 hover:border-neutral-600 hover:text-neutral-300"
                  }`}
                >
                  {f}
                </button>
              ))}
            </div>
          </Reveal>
        </div>

        <motion.div layout className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <AnimatePresence mode="popLayout">
            {items.map((g) => (
              <motion.figure
                layout
                key={g.url}
                initial={{ opacity: 0, scale: 0.96 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.96 }}
                transition={{ duration: 0.4 }}
                data-testid="gallery-item"
                className="group relative overflow-hidden rounded-sm border border-neutral-800 hover:border-torch/60 transition-colors aspect-[4/3]"
              >
                <img
                  src={g.url}
                  alt={g.caption}
                  loading="lazy"
                  className="w-full h-full object-cover grayscale-[30%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                />
                <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/90 to-transparent p-5 translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
                  <span className="font-mono text-[10px] tracking-[0.25em] text-torch uppercase">{g.category}</span>
                  <p className="text-sm text-neutral-200 mt-1">{g.caption}</p>
                </figcaption>
              </motion.figure>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </section>
  );
};
